import "./App.css";
import { Provider, useDispatch, useSelector } from "react-redux";
import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import AppRoutes from "./router";
import AppLogout from "./Component/AppLogout";
import ErrorBoundary from "./Component/ErrorBoundary";
import Holiday from "./Screen/Holiday";
import HttpClient from "./Services/HttpClient";
import useStore from "./Screen/redux/store/useStore";
import { AppProvider } from "./Services/AppContext";
import { BASE_URL, URLS, WEBSOCKET_URL } from "./Services/Constant";
import { get, post } from "./Services/ApiHandler";
// Firebase v9 imports
import { db } from "../src/Services/firebase";
import { ref, onValue, set, off } from "firebase/database";
import moment from "moment";
import "./consoleLogger";
import axios from "axios";
import RawWebsocket from "./Websocker/RawWebSocket";
import Loader from "./Component/Loader";
import store from "./Screen/redux/store/store";
import { saveCartList } from "./Screen/redux/slice/cartList";
import eventBus from "./Screen/EventEmitterr/eventBus";
import useStoreKv from "./LocalStore/useStore";

let heartbeatInterval = null;

// Backend/socket payloads occasionally send unexpected shapes; coerce to a
// safe primitive so a bad value never crashes a component that renders it.
function toSafeNumber(value, fallback = 0) {
  const n = Number(value);
  return Number.isFinite(n) ? n : fallback;
}

function AppContent() {
  const kvStore = useStoreKv();
  const dispatch = useDispatch();
  const cartList = useSelector((state) => state.cartList);
  const cartListRef = useRef(
    new Map(cartList?.map((item) => [item?.id, item])),
  );
  const { pathname } = useLocation();
  const splitPath = pathname?.split("/");
  const loaderDisable = ["wallet", "withdraw", "recharge"];
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const queryClient = new QueryClient();
  const {
    user,
    setSlot,
    setHoliday,
    setNotifyCount,
    holiday,
    setMessages,
    messages,
    clearMessages,
  } = useStore();
  const unread_message_count = useRef(messages?.unread);
  const onChat = useRef(messages?.onChat);
  const userId = user?.id;
  // // console.log("userId", userId);
  const slotsGameExpiriedIds = useRef(new Set());
  const empiryTimeOutIds = useRef([]);
  const initialCartLoaded = useRef(false);
  const addedBeforeInitialCartData = useRef([]);
  const resultData = useRef([]);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    unread_message_count.current = messages.unread;
    onChat.current = messages.onChat;
  }, [messages.unread, messages.onChat]);

  const defaultSlots = [
    { id: "1", started_at: "1 PM", game_name: "DEAR LOTTERY", status: 3 },
    { id: "2", started_at: "3 PM", game_name: "Kerala 3 PM", status: 3 },
    { id: "3", started_at: "6 PM", game_name: "DEAR LOTTERY", status: 3 },
    { id: "4", started_at: "8 PM", game_name: "DEAR LOTTERY", status: 3 },
  ];

  useEffect(() => {
    clearMessages?.();
    HttpClient.interceptors.request.use(
      function (config) {
        // spinning start to show
        setLoading(true);
        return config;
      },
      function (error) {
        setLoading(false);
        return Promise.reject(error);
      },
    );

    HttpClient.interceptors.response.use(
      function (response) {
        // spinning hide
        setLoading(false);
        return response;
      },
      function (error) {
        setLoading(false);
        return Promise.reject(error);
      },
    );
  }, []);

  //to store the cart data at initial loading
  const getCartList = async () => {
    setLoader(true);
    try {
      const res = await get(URLS.GAMECARTLIST);
      if (res?.status === "success" && Array.isArray(res?.data)) {
        const normalized = [];
        res.data.map((item) => {
          normalized.push({
            id: item.id,
            game_slot_id: item.game_slot_id,
            game_fee_price_id: item.fee_price_id,
            type: item.type,
            digit: item.digit,
            my_number: item.my_number,
            count: item.count,
            lot_details: item.lot_details, // ✅ FIX
            ticket_amount: item.ticket_amount,
            price: item.price,
          });
        });

        addCartToLocal(normalized);
        checkForRemoveCartData(resultData.current, normalized);
      }
      setLoader(false);
    } catch (err) {
      setLoader(false);
      // // console.log(err);
    }
  };

  useEffect(() => {
    let mapdata = new Map(cartList.map((item) => [item?.id, item]));
    // console.log("naw map data", [...mapdata.values()], cartList);
    cartListRef.current = mapdata;
  }, [cartList]);

  const addCartToLocal = (cartData) => {
    let beforeData = initialCartLoaded.current
      ? []
      : addedBeforeInitialCartData.current;
    let mappedData = new Map(
      [...cartData, ...beforeData].map((item) => [item?.id, item]),
    );
    let finalData = [...mappedData.values()];
    console.log("add cart to local ", finalData);
    dispatch(saveCartList(finalData));
    localStorage.setItem("cart", JSON.stringify(finalData));
    initialCartLoaded.current = true;
    addedBeforeInitialCartData.current = [];
  };

  // Check holiday status on mount (covers unauthenticated users on login page)
  useEffect(() => {
    const checkHoliday = async () => {
      try {
        const res = await axios.get(`${BASE_URL}${URLS.HOLIDAY}`);
        if (res?.data?.is_overall_holiday) {
          setHoliday("is_holiday", true);
          setHoliday("reason", res?.data?.overall_reason || "");
          localStorage.setItem("reason", res?.data?.overall_reason || "");
        } else {
          setHoliday("is_holiday", false);
          localStorage.removeItem("reason");
        }
      } catch {
        // Endpoint may require auth — fall back to persisted localStorage value
        const savedReason = localStorage.getItem("reason");
        if (savedReason) {
          setHoliday("is_holiday", true);
          setHoliday("reason", savedReason);
        }
      }
    };
    checkHoliday();
  }, []);

  const handleSocket = (reconnect) => {
    // console.log(
    //   "handle socket connection",
    //   localStorage.getItem("token"),
    //   sessionStorage.getItem("token"),
    // );
    let Tok = localStorage.getItem("token") || sessionStorage.getItem("token");
    if (Tok) {
      RawWebsocket.connect(
        `${WEBSOCKET_URL}?token=${encodeURIComponent(Tok)}`,
        userId,
      );
      RawWebsocket.clearListeners();
      RawWebsocket.listen("subscribed", (e) => {
        kvStore.set("walletAmount", toSafeNumber(e?.data?.wallet_amount));
        let lastCartId = e?.data?.last_cartid;
        let cartLength = e?.data?.cartCount;
        let localCart = JSON.parse(localStorage.getItem("cart") ?? "[]");
        let localCartSet = new Set(localCart.map((item) => item?.id));
        let isSame = localCartSet.has(lastCartId);
        console.log(
          "subcribtion event",
          e,
          isSame,
          cartLength,
          localCartSet.size,
        );
        if (isSame && localCartSet.size == cartLength) {
          initialCartLoaded.current = true;
          dispatch(saveCartList(localCart));
        } else getCartList();
      });

      //submitted listener
      RawWebsocket.listen("cart_submited", (e) => {
        if (e?.data?.submited) dispatch(saveCartList([]));
      });

      //wallet Listeners
      RawWebsocket.listen("wallet_update", (e) => {
        kvStore.set("walletAmount", toSafeNumber(e?.data?.wallet_amount));
      });

      RawWebsocket.listen("notification_unread", (e) => {
        console.log("notification_unread", e?.data);
        setNotifyCount(toSafeNumber(e?.data?.unread_count));
        setMessages("unread", toSafeNumber(e?.data?.unread_message_count));
      });

      //chat listeners
      RawWebsocket.listen("chat_message", (e) => {
        let d = e?.data;
        if (d?.is_admin_sender === 1 && !d?.seen)
          setMessages("unread", toSafeNumber(unread_message_count.current) + 1);
      });

      // daily game Slots
      RawWebsocket.listen("daily_game_slots", (e) => {
        // if (e?.data?.submited) console.log("daily_game_slots", e?.data);

        resultData.current = e?.data;
        checkForRemoveCartData(e?.data);
        const slot = e?.data;
        const arrayData = Object.values(slot).filter((item) => item !== null);
        const filledSlots = defaultSlots.map((defaultSlot, index) => {
          const apiSlot = arrayData[index];
          if (apiSlot) {
            // Merge API slot and keep API-driven status
            return {
              ...defaultSlot,
              ...apiSlot,
              btnRemove:
                [2, 3, 4, 5].includes(apiSlot?.status) ||
                moment().isAfter(
                  moment(apiSlot?.lot_closed_at, "YYYY-MM-DD HH:mm:ss"),
                ),
            };
          } else {
            return {
              ...defaultSlot,
              btnRemove: true,
              status: 3,
            };
          }
        });
        setSlot(filledSlots);
        setHoliday("reason", e?.holiday_reason);
        setHoliday("is_holiday", e?.is_overall_holiday);
      });

      //Cart Listeners
      RawWebsocket.listen("cart_result", (e) => {
        console.log("data cart_result", e);
        if (!e?.data || e?.data?.status === "error") return;
        let d = e?.data;
        let spreadedData = Array.isArray(e?.data)
          ? d?.map((item) => ({
              id: item.id,
              game_slot_id: item.game_slot_id,
              game_fee_price_id: item.fee_price_id,
              type: item.type,
              digit: item.digit,
              my_number: item.my_number,
              count: item.count,
              lot_details: item.lot_details, // ✅ FIX
              ticket_amount: item.ticket_amount,
              price: item.price,
            }))
          : [
              {
                id: d.id,
                game_slot_id: d.game_slot_id,
                game_fee_price_id: d.fee_price_id,
                type: d.type,
                digit: d.digit,
                my_number: d.my_number,
                count: d.count,
                lot_details: d.lot_details, // ✅ FIX
                ticket_amount: d.ticket_amount,
                price: d.price,
              },
            ];
        if (!initialCartLoaded.current) {
          console.log("data cart_result initial cart loaded", d);
          addedBeforeInitialCartData.current = [
            ...addedBeforeInitialCartData.current,
            ...spreadedData,
          ];
        } else {
          console.log("data cart_result initial cart loaded else", d);
          addCartToLocal([...cartListRef.current.values(), ...spreadedData]);
        }
      });

      RawWebsocket.listen("clear_cart", () => {
        dispatch(saveCartList([]));
        localStorage.setItem("cart", JSON.stringify([]));
      });

      RawWebsocket.listen("cart_delete", (e) => {
        let deletedIds = e?.data?.cartitem;
        (deletedIds ?? []).forEach((i) => {
          cartListRef.current.delete(i);
        });
        addCartToLocal([...cartListRef.current.values()], e?.data?.id);
      });
    } else {
      RawWebsocket.disconnect();
    }
  };

  const heartBeatRef = useRef(null);
  useEffect(() => {
    // // console.log("token change detected in heartbeat effect call");
    const token =
      localStorage.getItem("token") || sessionStorage.getItem("token");
    handleSocket();
    if (!token || !userId) return;
    // // console.log("token change detected in heartbeat effect started");
    const handleNewLogin = () => {
      initialCartLoaded.current = false;
      getCartList();
    };
    eventBus.on("newlogin", handleNewLogin);

    let isComponentMounted = true;
    const HEARTBEAT_INTERVAL = 3000; // 5 seconds for more real-time updates

    // Start heartbeat - updates every 5 seconds
    const startHeartbeat = () => {
      handleSocket(true);
    };

    // Stop heartbeat
    const stopHeartbeat = () => {
      RawWebsocket.disconnect();
      // if (heartbeatInterval) {
      //   clearInterval(heartbeatInterval);
      //   heartbeatInterval = null;
      // }
    };

    // Handle visibility change
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        startHeartbeat();
      } else {
        stopHeartbeat();
      }
    };

    startHeartbeat();

    // Add visibility listener
    document.addEventListener("visibilitychange", handleVisibilityChange);

    // Handle page refresh/close
    const handleBeforeUnload = () => {
      // // console.log(`👋 User ${userId} leaving`);
      isComponentMounted = false;
      stopHeartbeat();
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    // Cleanup on unmount
    return () => {
      // // console.log(`🧹 Cleaning up user ${userId}`);
      isComponentMounted = false;
      stopHeartbeat();
      eventBus.off("newlogin", handleNewLogin);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [userId, localStorage.getItem("token"), sessionStorage.getItem("token")]);

  useEffect(() => {
    //To store logFile into server
    const uploadLogCheck = ref(db, `/logFile/${userId}`);

    onValue(uploadLogCheck, (snap) => {
      let d = snap.val();
      if (!d) return;
      if (d?.uploadReactLog) {
        uploadLogFile(uploadLogCheck, d);
      }
    });
  }, [userId]);

  const uploadLogFile = async (firebaseDbRef, d) => {
    let logFile = await window.getLogFile();
    let payload = new FormData();
    payload.append("file", logFile, `${userId}_${Date.now()}react_logfile.txt`);
    payload.append("user_id", userId);
    console.log("logfile", logFile, userId, payload);
    try {
      const res = await axios.post(
        `${BASE_URL.replace("user/", "")}${URLS.UPLOAD_LOG}`,
        payload,
      );
      console.log("logfile upload", res);

      if (res?.data?.status === "success") {
        set(firebaseDbRef, {
          ...d,
          uploadReactLog: false,
          react_logUrl: res?.data?.url,
        });
        window.clearLogs();
      }
    } catch (error) {
      console.log("uploading logfile", error);
    }
  };

  const checkForRemoveCartData = (data, CData) => {
    empiryTimeOutIds.current.forEach((id) => clearTimeout(id));
    let timerIds = [];
    let cartData = CData
      ? CData
      : JSON.parse(localStorage.getItem("cart") ?? "[]");
    let cartSet = new Set(cartData?.map((item) => item?.game_slot_id));
    let expiredSlots = new Set();
    // console.log("cart data", cartData, cartSet, cartSet.size);
    data?.forEach((item) => {
      if (item?.booking_closed_at) {
        let timeoutTimer = moment(item?.booking_closed_at).diff(
          moment(),
          "milliseconds",
        );

        // // console.log("timer modified", timeoutTimer);
        if (timeoutTimer > 100) {
          let id = setTimeout(() => {
            checkForRemoveCartData(resultData.current);
          }, timeoutTimer);
          timerIds.push(id);
        } else {
          expiredSlots.add(item?.id);
          if (cartSet.has(item?.id)) {
            handleClearCart(true);
          }
        }
      }
    });
    slotsGameExpiriedIds.current = expiredSlots;
    empiryTimeOutIds.current = timerIds;
    // // console.log("game slot list", data);
  };

  const handleClearCart = async () => {
    try {
      RawWebsocket.emit("clear_cart", { client_id: userId });
      dispatch(saveCartList([]));
      localStorage.removeItem("cart");
      // setLoading(true);
      // const resClear = await post(`${URLS.ADDGAME}/clear`);

      // if (resClear.status === "success") {
      //   console.log("cart cleared successfully");
      // }
    } catch (err) {
      // // console.log(err);
    } finally {
      // setLoading(false);
    }
    empiryTimeOutIds.current?.forEach((id) => clearTimeout(id));
    empiryTimeOutIds.current = [];
  };

  return (
    <div>
      <QueryClientProvider client={queryClient}>
        {loader && <Loader />}
        {/* {loading && !loaderDisable?.includes(splitPath?.[1]) && <Loader />} */}
        <ErrorBoundary>
          <AppLogout>
            <AppProvider>
              {holiday?.is_holiday && <Holiday />}
              <AppRoutes />
              <ScrollToTop />
            </AppProvider>
          </AppLogout>
        </ErrorBoundary>
      </QueryClientProvider>
    </div>
  );
}

const App = () => {
  return (
    <div>
      <Provider store={store}>
        <AppContent />
      </Provider>
    </div>
  );
};
export default App;

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};
